import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { PrimaryButtonLink } from '~/components/primary-button-link';
import { SanityImage } from '~/components/sanity-image';
import { SchoolContent } from '~/features/school/models/school-content';

export type FeaturedSchoolSectionProps = {
  title?: string | null;
  description?: string | null;
  ctaLabel?: string | null;
  school?: Pick<SchoolContent, 'slug' | 'graphic2'> | null;
};

export function FeaturedSchoolSection({ title, description, ctaLabel, school }: FeaturedSchoolSectionProps) {
  return (
    <Box
      as='section'
      bgGradient='linear(180deg, #121881 0%, #171A53 100%)'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer
        color='white'
        display='flex'
        flexDirection={{
          base: 'column-reverse',
          md: 'row',
        }}
        gap={{
          base: 6,
          md: 8,
        }}
      >
        <Flex
          flex={{ md: '0 2 448px' }}
          flexDirection='column'
          gap={8}
          justifyContent={{ md: 'center' }}
          alignItems={{
            base: 'center',
            md: 'unset',
          }}
          textAlign={{
            base: 'center',
            md: 'start',
          }}
        >
          <Flex flexDirection='column' gap={2}>
            <Heading
              size={{
                base: 'marketing-3xl',
                md: 'marketing-4xl',
              }}
            >
              {title}
            </Heading>
            {!!description && <Text>{description}</Text>}
          </Flex>
          {!!ctaLabel && <PrimaryButtonLink href={`/school/${school?.slug}`} label={ctaLabel} width='fit-content' />}
        </Flex>
        <Box
          border='1px solid'
          borderColor='blue.500'
          borderRadius='8px'
          boxShadow='0px 0px 45px 0px #2015FF80'
          overflow='hidden'
          position='relative'
          flex={{
            base: '0 0 225px',
            md: '1 1 600px',
          }}
          height={{
            base: '225px',
            md: '340px',
          }}
        >
          {!!school?.graphic2 && (
            <SanityImage
              image={school.graphic2}
              loading='lazy'
              sizes='600px'
              style={{
                objectFit: 'cover',
                pointerEvents: 'none',
              }}
              fill
            />
          )}
        </Box>
      </ContentContainer>
    </Box>
  );
}
